import React from 'react';
import styled from '@emotion/native';
import { green, pillBrown } from '@/shared/styles/colors';
import { BaseText } from '@/shared/components/StyledText';

interface FilterPillProps {
  label: string;
  onRemove: () => void;
}

const FilterPill: React.FC<FilterPillProps> = ({ label, onRemove }) => (
  <PillBase>
    <PillText>{label}</PillText>
    <RemoveButton onPress={onRemove}>
      <RemoveIcon source={require('@/assets/images/Clear.png')} />
    </RemoveButton>
  </PillBase>
);

const PillBase = styled.View({
  backgroundColor: pillBrown,
  minWidth: 101,
  height: 27,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingHorizontal: 8,
  marginRight: 7,
});

const PillText = styled(BaseText)({
  color: green,
  fontSize: 10,
  fontWeight: 'bold',
  marginRight: 11,
});

const RemoveButton = styled.TouchableOpacity({});

const RemoveIcon = styled.Image({
  width: 19,
  height: 19,
});

export default FilterPill;
